import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import { API_BASE_URL } from "../Config";
import { Alert, Row, Col, Spinner, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { CartContext } from "../contexts/CartContext";
import { MaintenanceModeContext } from "../contexts/MaintenanceModeContext";
import { SvgErrorAlert } from "../components/Svgs";
import ProductDetail from "../components/ProductDetail";

function ProductDetailScreen() {
  const { t } = useTranslation();
  const { slug } = useParams();

  const fetcher = (url) => fetch(url).then((res) => res.json());
  const { data, error, isLoading } = useSWR(`${API_BASE_URL}/api/slug/${slug}`, fetcher);

  const maintenanceMode = useContext(MaintenanceModeContext);

  const [alertShownForProduct, setAlertShownForProduct] = useState({});

  const { products, setProducts, totalPlacedInCart } = useContext(CartContext);

  useEffect(() => {
      // ✅ Aguarda até que os dados do produto estejam prontos
      if (!data || !data.products) return;

      // 🔄 Atualiza os produtos no contexto
      setProducts(data.products);

      // 🔍 Percorre cada produto e verifica se o usuário adicionou 10 ou mais unidades ao carrinho
      data.products.forEach((item) => {
        const quantityInCart = totalPlacedInCart[item.id] || 0; // Garante que `undefined` vire `0`
        
        // ⚠️ Se a quantidade no carrinho atingir o limite e o alerta ainda não tiver sido mostrado, exibe um aviso
        if (quantityInCart >= 10 && !alertShownForProduct[item.id]) {
          setAlertShownForProduct((prev) => ({
            ...prev,
            [item.id]: item.product_name,
          }));

          // 📜 Faz scroll até o topo para garantir que o alerta fique visível
          document.getElementById("root").scrollIntoView();
        }
      });
  }, [data]); // 🔥 Reduzimos as dependências para evitar execuções desnecessárias



  if (maintenanceMode) {
    return <div className="text-center pt-5">{t('website_maintenance')}</div>;
  } else if (isLoading || !products) {
    return (
      <div className="spinning">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <Container className="pt-4">
        <h3 className="pb-md-1">{t('details')}</h3>

        {Object.keys(alertShownForProduct).length > 0 && (
          <Alert variant="warning" dismissible>
            {t('max_units_warning')} <br></br>
            {Object.values(alertShownForProduct).map((product, index) => (
              <React.Fragment key={index}>
                {product}
                <br />
              </React.Fragment>
            ))}
          </Alert>
        )}
        {isLoading && (
          <div className="spinning">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">{t('loading')}</span>
            </Spinner>
          </div>
        )}
        {error && (
          <Alert variant="danger">
            <SvgErrorAlert /> {t('fetch_error')}
          </Alert>
        )}

        {data && data.product && (
          <Row>
            <Col className="my-2 card-border" sm={12} key={data.product.id}>
              <ProductDetail product={data.product} />
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

export default ProductDetailScreen;
